import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
const forYou = ['Sentís que necesitás dedicarte un momento, pero no sabés cómo comenzar.', 'Te interesan las prácticas energéticas, los rituales y las herramientas de autocuidado.', 'Querés comprender mejor lo que estás sintiendo y elegir una práctica relacionada.', 'Buscás propuestas breves que puedas adaptar a tu tiempo.', 'Preferís tener todo organizado dentro de un mismo sistema visual.', 'Querés registrar tu experiencia y observar qué prácticas te hacen bien.', 'Te gustaría crear pequeños momentos de pausa, reflexión y conexión personal.'];
const notForYou = ['Buscás una solución instantánea que garantice resultados sin realizar ninguna práctica.', 'Esperás que un material digital reemplace la atención médica, psicológica o profesional.', 'No tenés interés en el autocuidado, la reflexión personal ni las prácticas energéticas.', 'Buscás diagnósticos, tratamientos o indicaciones clínicas.', 'Preferís seguir una rutina rígida e idéntica para todas las personas.', 'Esperás utilizar todos los recursos al mismo tiempo o alcanzar una experiencia “perfecta”.'];
export function AudienceSection() {
  return <section className="w-full bg-cream px-5 py-12 sm:py-20" data-id="element-9" data-mp="uj6hwh914exp">
      <div className="mx-auto max-w-5xl" data-id="element-10" data-mp="qicrnh846o1n">
        <div className="mx-auto max-w-2xl text-center" data-id="element-11" data-mp="qhbe963mlpgr">
          <h2 className="font-serif-display text-2xl font-bold leading-tight text-plum sm:text-4xl" data-id="element-12" data-mp="llcjn0rpfb7w">
            Aura Viva 2026 puede ser para vos si...
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-plum/75 sm:text-base" data-id="element-13" data-mp="blvfwow0j7ek">
            Este sistema fue creado para acompañar un proceso personal de autocuidado consciente,
            flexible y posible de adaptar a tu vida.
          </p>
        </div>

        <div className="mt-10 grid gap-6 md:grid-cols-2" data-id="element-14" data-mp="25zd7cmzjgoev">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-aura/20 bg-lavender p-6 ring-1 ring-inset ring-gold/20 sm:p-8" data-id="element-15" data-mp="21yb4zxabrw8o">
            <h3 className="mb-6 text-lg font-bold text-plum sm:text-xl" data-id="element-16" data-mp="3mesf63xqipz7">
              Sí puede acompañarte si...
            </h3>
            <ul className="space-y-4" data-id="element-17" data-mp="i1voo0v9wcw4">
              {forYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-18" data-mp="n1hye0bw7b06">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-aura/15 text-aura" data-id="element-19" data-mp="n0p0louwvvu6">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-20" data-mp="e0s636luc2r7" />
                  </span>
                  <span className="text-sm leading-relaxed text-plum/80" data-id="element-21" data-mp="2trxzrlfrygsl">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          amount: 0.2
        }} transition={{
          duration: 0.3,
          delay: 0.08,
          ease: [0.23, 1, 0.32, 1]
        }} className="rounded-2xl border border-rose/50 bg-card p-6 sm:p-8" data-id="element-22" data-mp="2ysly6s6c1zwu">
            <h3 className="mb-6 text-lg font-bold text-plum sm:text-xl" data-id="element-23" data-mp="2v93m7lhuzfla">No es para vos si...</h3>
            <ul className="space-y-4" data-id="element-24" data-mp="27jiry6g98vwp">
              {notForYou.map(item => <li key={item} className="flex items-start gap-3" data-id="element-25" data-mp="27hg5txi83mx9">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-rose/15 text-rose" data-id="element-26" data-mp="22lqyh7zyp1qe">
                    <XIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-27" data-mp="2hbf3okb9kkje" />
                  </span>
                  <span className="text-sm leading-relaxed text-plum/80" data-id="element-28" data-mp="2cgiwue1dbsm8">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>

        <p className="mx-auto mt-10 max-w-2xl text-center text-base leading-relaxed text-plum sm:text-lg" data-id="element-29" data-mp="1jt5996jk89es">
          Aura Viva 2026 no busca decirte cómo deberías sentirte. Busca ofrecerte recursos para que
          puedas escucharte y{' '}
          <span className="font-semibold text-aura" data-id="element-30" data-mp="w39ex84oqif5">elegir conscientemente tu próximo paso</span>.
        </p>

        <p className="mx-auto mt-6 max-w-2xl text-center text-xs leading-relaxed text-plum/70 sm:text-sm" data-id="element-31" data-mp="10tpscs8ia41i">
          Este producto es un recurso educativo de bienestar y autocuidado. No diagnostica, trata ni
          reemplaza la atención de profesionales de la salud.
        </p>
      </div>
    </section>;
}